import React from 'react';
import { styled, useTheme } from "styled-components";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

const SearchTextField = styled(TextField)`
  width: 100%;
  margin-bottom: 12px !important;
  background: transparent;
  border-radius: 4px;
  
  .MuiOutlinedInput-root {
    height: 38px;
    font-size: 14px;
    border-radius: 4px;
    
    .MuiOutlinedInput-notchedOutline {
      border-width: 1px;
      border-color: ${({ theme }) => theme.colors.divider};
    }
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.colors.buttonBorder};
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.colors.highlight6};
      border-width: 1px;
    }
  }
`;

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ 
  placeholder = "Search...", 
  value, 
  onChange 
}) => {
  const theme = useTheme();
  
  return (
    <SearchTextField
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" style={{ color: theme.colors.lightGrey }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;